module.exports = __webpack_public_path__ + "36b651b336e6caf556ff618115f5aada.jpg";